var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 104,
    viewBox: "0 0 118 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 35.06C71.0812 35.06 62.5612 34.72 54.5912 32.5C46.7712 30.33 39.5912 26.12 33.1912 21.25C29.0012 18.08 25.1912 15.55 19.7512 15.93C14.4293 16.218 9.34 18.2053 5.23121 21.6C-1.68879 27.66 -0.648793 38.89 2.12121 46.75C6.28121 58.62 18.9412 66.89 29.7012 72.24C42.1312 78.45 55.7812 82.06 69.4812 84.13C81.4812 85.96 96.9012 87.28 107.301 79.45C116.851 72.24 119.471 55.8 117.131 44.7C116.563 41.4209 114.817 38.4621 112.221 36.38C105.511 31.47 95.5012 34.75 87.9612 34.91C85.1612 34.97 82.3112 35.04 79.4512 35.06Z",
    fill: "#3B0069",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0512 81.93H27.5212V38.09L60.8512 15.17L94.0512 38.09V81.93Z",
    fill: "#3B0069"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3389 8.53312L29.3123 21.5907C27.7987 22.0022 26.9054 23.5627 27.3169 25.0763L38.0132 64.4181C38.4247 65.9317 39.9853 66.8251 41.4988 66.4135L89.5254 53.356C91.0389 52.9445 91.9323 51.3839 91.5208 49.8704L80.8245 10.5285C80.413 9.015 78.8524 8.12162 77.3389 8.53312Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0512 82.2H27.5212V38.37L59.1512 58.43L94.0512 38.37V82.2Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5212 82.2L58.9012 52.2C59.493 51.6246 60.2858 51.3026 61.1112 51.3026C61.9366 51.3026 62.7295 51.6246 63.3212 52.2L94.0512 82.2H27.5212Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2112 42.8C51.0882 40.4675 51.7679 38.1632 53.1372 36.2708C54.5065 34.3785 56.4826 33.0122 58.7366 32.3996C60.9906 31.787 63.3865 31.965 65.5252 32.9039C67.664 33.8429 69.4166 35.4861 70.4912 37.56",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2313 25.77C69.0155 25.77 69.6513 25.1342 69.6513 24.35C69.6513 23.5657 69.0155 22.93 68.2313 22.93C67.447 22.93 66.8113 23.5657 66.8113 24.35C66.8113 25.1342 67.447 25.77 68.2313 25.77Z",
    fill: "#3B0069"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4713 31.69C47.2555 31.69 47.8913 31.0543 47.8913 30.27C47.8913 29.4858 47.2555 28.85 46.4713 28.85C45.687 28.85 45.0513 29.4858 45.0513 30.27C45.0513 31.0543 45.687 31.69 46.4713 31.69Z",
    fill: "#3B0069"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8213 23.66C93.3625 23.66 93.8013 23.2213 93.8013 22.68C93.8013 22.1388 93.3625 21.7 92.8213 21.7C92.2801 21.7 91.8413 22.1388 91.8413 22.68C91.8413 23.2213 92.2801 23.66 92.8213 23.66Z",
    fill: "#3B0069"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4912 73.8C23.0325 73.8 23.4712 73.3613 23.4712 72.82C23.4712 72.2788 23.0325 71.84 22.4912 71.84C21.95 71.84 21.5112 72.2788 21.5112 72.82C21.5112 73.3613 21.95 73.8 22.4912 73.8Z",
    fill: "#3B0069"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.221 22.2V26.51",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.071 24.36H111.371",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M103.401 89.52V93.82",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.251 91.67H105.551",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9211 0.5V4.8",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7712 2.65002H23.0712",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3714 103.59C79.6458 103.59 96.0814 102.565 96.0814 101.3C96.0814 100.035 79.6458 99.01 59.3714 99.01C39.097 99.01 22.6614 100.035 22.6614 101.3C22.6614 102.565 39.097 103.59 59.3714 103.59Z",
    fill: "#3B0069",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessage);
export default __webpack_public_path__ + "static/media/NoMessage.c39d4748d007644a8c39cb80328b1bf4.svg";
export { ForwardRef as ReactComponent };